export default __webpack_public_path__ + "static/media/plus-circle.e11ef57c.svg";